module.exports = __webpack_public_path__ + "static/media/nodejs_logo.5b47d4f8.png";